export const TOAST_DURATION = 1000;
export const TOAST_DURATION_LONG = 3000;